import { render, staticRenderFns } from "./UserSettingsDialog.vue?vue&type=template&id=6fe37b66&scoped=true"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=js"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsDialog.vue?vue&type=style&index=0&id=6fe37b66&prod&scoped=true&lang=css"
import style1 from "./UserSettingsDialog.vue?vue&type=style&index=1&id=6fe37b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe37b66",
  null
  
)

export default component.exports